// 抑制 ResizeObserver 错误的工具文件
// 这个错误不影响功能，只是在开发环境中产生噪音

// 方法1：重写 ResizeObserver 构造函数
const originalResizeObserver = window.ResizeObserver;
const originalError = console.error;

// 重写 console.error 来过滤 ResizeObserver 错误
console.error = (...args) => {
  const message = args.join(' ');
  if (message.includes('ResizeObserver loop completed') || 
      message.includes('ResizeObserver loop limit exceeded')) {
    return; // 忽略这些错误
  }
  originalError.apply(console, args);
};

// 重写 ResizeObserver
window.ResizeObserver = class extends originalResizeObserver {
  constructor(callback) {
    const wrappedCallback = (entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (error) {
          if (error.message && (
            error.message.includes('ResizeObserver loop completed') ||
            error.message.includes('ResizeObserver loop limit exceeded')
          )) {
            // 忽略这些错误
            return;
          }
          throw error;
        }
      });
    };
    super(wrappedCallback);
  }
};

// 方法2：全局错误处理
window.addEventListener('error', (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop completed') ||
    e.message.includes('ResizeObserver loop limit exceeded')
  )) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
});

// 方法3：unhandledrejection 处理
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && (
    e.reason.message.includes('ResizeObserver loop completed') ||
    e.reason.message.includes('ResizeObserver loop limit exceeded')
  )) {
    e.preventDefault();
    return false;
  }
});

export default {};
